import React from "react";

const BASEDIR = "../../assets/";
const IMAGES_ARTICLE1 = [
	"code.jpg",
	"main-non-reg.jpg",
	"succes-reg.jpg",
	"reg-sms.jpg",
	"pas.jpg",
	"main-menu.jpg",
];

const DEMO_IMAGES = IMAGES_ARTICLE1.map((image, index) => (
	<img src={BASEDIR + image} width="25%" alt="img" />
));

const ARTICLE_STYLES = `
.article-content {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.randImage {
	align-self: center;
	outline: 2px solid red;
}

.paragraph {
	padding: 10px;
}
.highlight {
	textalign: center;
}
.demo-container {
	background-color: #0b0d40;
	width: 100%;
	margin: 2rem
	color: #fff;
}
.images-container {
	display: flex;
	text-align: center;
}
.demo,a {
	padding: 1rem;
	color: #fff;
	text-align: center;
}
`;

const article_1 = () => {
	return {
		date: "7 June 2023",
		title: "USSD and SMS integrated system for VICOBA services",
		description:
			"A study implementation for USSD and SMS integrated system for Village Community Banks (VCOBA) in Tanzania",
		keywords: [
			"VICOBA",
			"USSD and SMS",
			"Africas talking USSD",
			"Village Community Banks",
		],
		style: ARTICLE_STYLES,
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="paragraph">
						<strong style={{ fontSize: "40px" }}>V</strong>illage
						Community Banking (VICOBA) are microfinance initiative
						that plays a crucial role in empowering rural
						communities through savings and lending activities.
					</div>
					<div className="paragraph">
						A USSD AND SMS system for VICOBA,digitizes the
						paper-based VICOBA operations and introduces mobile
						technology to provide members with a user-friendly
						platform. With the system, members can access VICOBA
						services conveniently through USSD codes or SMS
						messages.
					</div>
					<div className="paragraph">
						The system encompasses features such as user
						registration, login, transaction management, and group
						management, making financial activities more accessible
						and efficient for VICOBA members.
					</div>
					<div className="paragraph">
						<div className="images-container">
							<div className="image">{DEMO_IMAGES}</div>
						</div>
					</div>

					<div className="demo-container">
						<div className="demo">
							Demo Details:
							<br />
							<span>USSD Code: *384*10105#</span>
							<br />
							<span>Phone: Any Tanzanian Phone (+255)</span>
							<br />
							<a
								href="https://developers.africastalking.com/simulator"
								target="_blank"
								rel="noreferrer"
							>
								Run Demo
							</a>
						</div>
					</div>
				</div>
			</React.Fragment>
		),
	};
};

const myArticles = [article_1];

export default myArticles;
